import { RowFormLabelPassengerDto } from "@/dtos";
import { Passenger, PassengerLabel } from "@/entities";

export const formatRowFormLabelPassengerDto = (passengers: Passenger[]): RowFormLabelPassengerDto[] => {
    return passengers.map(x => {
        const row: RowFormLabelPassengerDto = {
            idPassenger: x.id,
            name: x.first_name + " " + x.last_name,
            identification: x.identification.identification
        }

        return row;
    });
}

export const formatPassengerLabelSelected = (rows: RowFormLabelPassengerDto[], passengerLabels: PassengerLabel[]) => {
    const rowsSelected = [] as RowFormLabelPassengerDto[];
    passengerLabels.map(x => {
        const row = rows.find(p => p.idPassenger == x.passenger.id);
        if (row) {
            rowsSelected.push(row);
        }
    });

    return rowsSelected;
}